import { Badge, Box, Card, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

type ContentSectionProps = {
  header?: string;
  showHeaderCounter?: boolean;
  headerCounter?: number;
  showAlertBadge?: boolean;
  hasError?: boolean;
  button?: JSX.Element;
  transparentBackground?: boolean;
  children: ReactNode;
  mb?: number;
  border?: boolean;
};

export const ContentSection = (props: ContentSectionProps) => {
  const {
    header = undefined,
    showHeaderCounter = false,
    headerCounter = 0,
    showAlertBadge = false,
    mb = undefined,
    border = true,
    hasError = false,
    button = undefined,
    transparentBackground = false,
    children,
  } = props;

  return (
    <Card
      sx={{
        ...(hasError ? { borderWidth: 2, borderStyle: 'solid', borderColor: 'error.dark' } : null),
        position: 'relative',
        backgroundColor: transparentBackground ? 'transparent' : '#fff',
        mb,
      }}
      {...(hasError ? { variant: 'outlined' } : null)}
      elevation={0}
    >
      {header && (
        <>
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Typography variant='h6' sx={{ fontWeight: 700 }} gutterBottom>
              {showAlertBadge ? (
                <Badge
                  badgeContent={headerCounter && headerCounter}
                  sx={{ '.MuiBadge-badge': { marginRight: '-18px', marginTop: '10px' } }}
                  color='error'
                  // anchorOrigin={{
                  //   vertical: 'top',
                  //   horizontal: 'left',
                  // }}
                >
                  {header}
                </Badge>
              ) : (
                <>
                  {header}
                  {showHeaderCounter && (
                    <Typography
                      component='span'
                      sx={{
                        fontWeight: 100,
                        ml: 0.5,
                      }}
                    >
                      {`(${headerCounter})`}
                    </Typography>
                  )}
                </>
              )}
            </Typography>
            {button}
          </Box>
          {border && <Divider sx={{ mb: 1 }} />}
        </>
      )}
      {children}
    </Card>
  );
};
